interface Props {
  form: any;
}

const DebitNoteTotals = ({ form }: Props) => {
  const subtotal = form.taxableSubtotal || 0; // 💡 Ahora es solo "subtotal"
  const ivaAmount = form.calculatedIVA || 0;
  const totalToCharge = subtotal + ivaAmount;

  return (
    <div className="w-full max-w-md space-y-4 text-sm uppercase">
      <p className="flex justify-between text-gray-700 dark:text-gray-300 font-medium">
        <span>Subtotal</span>
        <span>${subtotal.toFixed(2)}</span>
      </p>
      <p className="flex justify-between text-gray-700 dark:text-gray-300 font-medium">
        <span>IVA 13%</span>
        <span>${ivaAmount.toFixed(2)}</span>
      </p>
      <p className="flex justify-between border-t pt-4 font-semibold text-gray-900 dark:text-white dark:border-strokedark">
        <span>Total a Cobrar</span>
        <span>${totalToCharge.toFixed(2)}</span>
      </p>
    </div>
  );
};

export default DebitNoteTotals;
